/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import { code } from 'codemash';
import { Config } from 'configs';
import { manageFunctionResponse } from 'utils/errorHandler';
import { apiActionChooser } from 'utils/apiActionChooser';
import { functionRequest } from './client/requests';

export const savePaymentAccount = async ({ token, data, alertController }) => {
  try {
    const response = await code.executeFunction({
      secretKey: token,
      functionId: Config.DATA.FUNCTIONS.SAVE_PAYMENT_ACCOUNT,
      data: {
        token,
        ...data,
      },
    });

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not save integration' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying save integration', e);

    if (alertController) {
      alertController.error({ text: 'Could not save integration' });
    }
  }

  return null;
};

export const getTipsForAssignment = async ({ token, companyId, restaurantId, alertController }) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: '8fe93f95-728b-4307-bad2-105f3c110d81',
          data: {
            token,
            restaurantId,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'GetTipsDistribution',
          data: JSON.stringify({ restaurantId }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not get tips to assign' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to get tips to assign', e);

    if (alertController) {
      alertController.error({ text: 'Could not get tips to assign' });
    }
  }

  return null;
};

export const distributeUnassignedTips = async ({
  token,
  companyId,
  restaurantId,
  distributions,
  fromDate,
  toDate,
  alertController,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: '989ebd60-5890-4711-be14-fd7ed846a764',
          data: {
            token,
            restaurantId,
            distributions,
            fromDate,
            toDate,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'DistributeUnassignedTips',
          data: JSON.stringify({
            restaurantId,
            distributions,
            fromDate,
            toDate,
          }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not assign tips' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to assign tips', e);

    if (alertController) {
      alertController.error({ text: 'Could not assign tips' });
    }
  }

  return null;
};
